var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrIran(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_19734)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.375 0H-9.375V45H69.375V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.375 30.2168H-9.375V45H69.375V30.2168Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3984 30.8496H50.0918V31.1396H54.3984V30.8496ZM53.7568 32.3262H53.458V32.6162H53.7568V32.3262ZM50.0742 32.3262V32.6162H50.9355V32.3174L50.0742 32.3262ZM49.6172 30.8496H49.3184V32.6074H49.6172V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8945 32.3174V32.6162H49.5293V32.3174H47.8945ZM50.9355 31.623H50.6543V32.6162H50.9443L50.9355 31.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1406 30.8496H47.8418V32.6074H48.1406V30.8496ZM48.8789 30.8496H48.5889V32.6074H48.8789V30.8496ZM52.8164 31.5527V31.8516H54.3984V31.5527H52.8164ZM49.3623 31.5527V31.8516H50.9443V31.5527H49.3623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9355 31.6318H50.6543V32.6074H50.9443L50.9355 31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9355 31.6318H50.6543V32.6074H50.9443L50.9355 31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9355 31.6318H50.6543V32.6074H50.9443L50.9355 31.6318ZM54.3896 31.6318H54.0996V32.6074H54.3896V31.6318ZM51.8584 31.6318H51.5596V32.6074H51.8584V31.6318ZM53.1152 31.6318H52.8164V32.6074H53.1152V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6562 32.3174V32.6162H52.9834V32.3174H51.6562ZM51.5684 31.5527V31.8516H52.4121V31.5527H51.5684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4824 30.8496H57.1758V31.1396H61.4824V30.8496ZM60.8408 32.3262H60.542V32.6162H60.8496L60.8408 32.3262ZM57.1582 32.3262V32.6162H58.0195V32.3174L57.1582 32.3262ZM56.7012 30.8496H56.4023V32.6074H56.7012V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9785 32.3174V32.6162H56.6133V32.3174H54.9785ZM58.0195 31.623H57.7295V32.6162H58.0195V31.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2246 30.8496H54.9258V32.6074H55.2246V30.8496ZM55.9629 30.8496H55.6729V32.6074H55.9629V30.8496ZM59.9004 31.5527V31.8516H61.4824V31.5527H59.9004ZM56.4463 31.5527V31.8516H58.0283V31.5527H56.4463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0195 31.6318H57.7295V32.6074H58.0195V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0195 31.6318H57.7295V32.6074H58.0195V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0195 31.6318H57.7295V32.6074H58.0195V31.6318ZM61.4736 31.6318H61.1836V32.6074H61.4736V31.6318ZM58.9424 31.6318H58.6523V32.6074H58.9424V31.6318ZM60.1992 31.6318H59.9004V32.6074H60.1992V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7402 32.3174V32.6162H60.0586V32.3174H58.7402ZM58.6523 31.5527V31.8516H59.4961V31.5527H58.6523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.376 30.8496H43.0693V31.1396H47.376V30.8496ZM46.7344 32.3262H46.4355V32.6162H46.7344V32.3262ZM43.0518 32.3262V32.6162H43.9131V32.3174L43.0518 32.3262ZM42.5859 30.8496H42.2871V32.6074H42.5859V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8721 32.3174V32.6162H42.5068V32.3174H40.8721ZM43.9131 31.623H43.6143V32.6162H43.9131V31.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1182 30.8496H40.8193V32.6074H41.1182V30.8496ZM41.8564 30.8496H41.5576V32.6074H41.8652L41.8564 30.8496ZM45.7939 31.5527V31.8516H47.376V31.5527H45.7939ZM42.3398 31.5527V31.8516H43.9219V31.5527H42.3398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9131 31.6318H43.6143V32.6074H43.9131V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9131 31.6318H43.6143V32.6074H43.9131V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9131 31.6318H43.6143V32.6074H43.9131V31.6318ZM47.3672 31.6318H47.0684V32.6074H47.3672V31.6318ZM44.8359 31.6318H44.5371V32.6074H44.8359V31.6318ZM46.0928 31.6318H45.7939V32.6074H46.0928V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.625 32.3174V32.6162H45.9609V32.3174H44.625ZM44.5371 31.5527V31.8516H45.3809V31.5527H44.5371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3096 30.8496H35.9941V31.1396H40.3008L40.3096 30.8496ZM39.6592 32.3262H39.3691V32.6162H39.6592V32.3262ZM35.9854 32.3262V32.6162H36.8467V32.3174L35.9854 32.3262ZM35.5195 30.8496H35.2207V32.6074H35.5195V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7969 32.3174V32.6162H35.4316V32.3174H33.7969ZM36.8467 31.623H36.5479V32.6162H36.8467V31.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.043 30.8496H33.7441V32.6074H34.043V30.8496ZM34.79 30.8496H34.4912V32.6074H34.79V30.8496ZM38.7275 31.5527V31.8516H40.3008V31.5527H38.7275ZM35.2734 31.5527V31.8516H36.8467V31.5527H35.2734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8467 31.6318H36.5479V32.6074H36.8467V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8467 31.6318H36.5479V32.6074H36.8467V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8467 31.6318H36.5479V32.6074H36.8467V31.6318ZM40.3008 31.6318H40.002V32.6074H40.3008V31.6318ZM37.7695 31.6318H37.4707V32.6074H37.7695V31.6318ZM39.0176 31.6318H38.7275V32.6074H39.0176V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5586 32.3174V32.6162H38.8857V32.3174H37.5586ZM37.4707 31.5527V31.8516H38.3145V31.5527H37.4707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.208 30.8496H28.9014V31.1396H33.208V30.8496ZM32.5664 32.3262H32.2676V32.6162H32.5664V32.3262ZM28.8838 32.3262V32.6162H29.7451V32.3174L28.8838 32.3262ZM28.418 30.8496H28.1279V32.6074H28.418V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7041 32.3174V32.6162H28.3389V32.3174H26.7041ZM29.7451 31.623H29.4463V32.6162H29.7451V31.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9502 30.8496H26.6514V32.6074H26.9502V30.8496ZM27.6885 30.8496H27.3896V32.6074H27.6885V30.8496ZM31.626 31.5527V31.8516H33.208V31.5527H31.626ZM28.1719 31.5527V31.8516H29.7539V31.5527H28.1719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7451 31.6318H29.4463V32.6074H29.7451V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7451 31.6318H29.4463V32.6074H29.7451V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7451 31.6318H29.4463V32.6074H29.7451V31.6318ZM33.1992 31.6318H32.9092V32.6074H33.1992V31.6318ZM30.668 31.6318H30.3691V32.6074H30.668V31.6318ZM31.9248 31.6318H31.626V32.6074H31.9336L31.9248 31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.457 32.3174V32.6162H31.793V32.3174H30.457ZM30.3691 31.5527V31.8516H31.2305V31.5527H30.3691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.375 0H-9.375V14.7832H69.375V0Z",
    fill: "#239F40"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0713 30.8496H21.7646V31.1396H26.0713V30.8496ZM25.4297 32.3262H25.1309V32.6162H25.4297V32.3262ZM21.7471 32.3262V32.6162H22.6172V32.3174L21.7471 32.3262ZM21.2812 30.8496H20.9912V32.6074H21.2812V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5674 32.3174V32.6162H21.2021V32.3174H19.5674ZM22.6084 31.623H22.3096V32.6162H22.6172L22.6084 31.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8047 30.8496H19.5147V32.6074H19.8047V30.8496ZM20.5518 30.8496H20.2529V32.6074H20.5518V30.8496ZM24.4893 31.5527V31.8516H26.0713V31.5527H24.4893ZM21.0352 31.5527V31.8516H22.6172V31.5527H21.0352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6172 31.6318H22.3096V32.6074H22.6172V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6172 31.6318H22.3096V32.6074H22.6172V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6172 31.6318H22.3096V32.6074H22.6172V31.6318ZM26.0625 31.6318H25.7637V32.6074H26.0625V31.6318ZM23.5312 31.6318H23.2324V32.6074H23.5312V31.6318ZM24.7881 31.6318H24.4893V32.6074H24.7881V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3203 32.3174V32.6162H24.6562V32.3174H23.3203ZM23.2324 31.5527V31.8516H24.0762V31.5527H23.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9785 30.8496H14.6719V31.1396H18.9785V30.8496ZM18.3369 32.3262H18.0381V32.6162H18.3369V32.3262ZM14.6455 32.3262V32.6162H15.5156V32.3174L14.6455 32.3262ZM14.1885 30.8496H13.8896V32.6074H14.1885V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4746 32.3174V32.6162H14.1094V32.3174H12.4746ZM15.5156 31.623H15.2168V32.6162H15.5156V31.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7119 30.8496H12.4219V32.6074H12.7119V30.8496ZM13.459 30.8496H13.1602V32.6074H13.459V30.8496ZM17.3965 31.5527V31.8516H18.9697V31.5527H17.3965ZM13.9424 31.5527V31.8516H15.5156V31.5527H13.9424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5156 31.6318H15.2168V32.6074H15.5156V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5156 31.6318H15.2168V32.6074H15.5156V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5156 31.6318H15.2168V32.6074H15.5156V31.6318ZM18.9697 31.6318H18.6709V32.6074H18.9697V31.6318ZM16.4385 31.6318H16.1396V32.6074H16.4385V31.6318ZM17.6953 31.6318H17.3965V32.6074H17.6865L17.6953 31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2275 32.3174V32.6162H17.5547V32.3174H16.2275ZM16.1396 31.5527V31.8516H16.9922V31.5527H16.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.877 30.8496H7.57031V31.1396H11.877V30.8496ZM11.2354 32.3262H10.9365V32.6162H11.2354V32.3262ZM7.55274 32.3262V32.6162H8.41406V32.3174L7.55274 32.3262ZM7.09571 30.8496H6.79688V32.6074H7.09571V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37305 32.3174V32.6162H7.00781V32.3174H5.37305ZM8.42285 31.623H8.12402V32.6162H8.42285V31.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61914 30.8496H5.32031V32.6074H5.61914V30.8496ZM6.35742 30.8496H6.06738V32.6074H6.35742V30.8496ZM10.2949 31.5527V31.8516H11.877V31.5527H10.2949ZM6.84082 31.5527V31.8516H8.42285V31.5527H6.84082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41406 31.6318H8.12402V32.6074H8.41406V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41406 31.6318H8.12402V32.6074H8.41406V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41406 31.6318H8.12402V32.6074H8.41406V31.6318ZM11.877 31.6318H11.5781V32.6074H11.877V31.6318ZM9.33691 31.6318H9.04688V32.6074H9.33691V31.6318ZM10.5938 31.6318H10.2949V32.6074H10.5938V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13477 32.3174V32.6162H10.4619V32.3174H9.13477ZM9.04687 31.5527V31.8516H9.89063V31.5527H9.04687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74023 30.8496H0.433594V31.1396H4.74023V30.8496ZM4.09863 32.3262H3.79981V32.6162H4.09863V32.3262ZM0.41602 32.3262V32.6162H1.27735V32.3174L0.41602 32.3262ZM-0.0410123 30.8496H-0.339843V32.6074H-0.0410123V30.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.76368 32.3174V32.6162H-0.128906V32.3174H-1.76368ZM1.27734 31.623H0.987306V32.6162H1.27734V31.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.51757 30.8496H-1.8164V32.6074H-1.51757V30.8496ZM-0.779296 30.8496H-1.06933V32.6074H-0.779296V30.8496ZM3.1582 31.5527V31.8516H4.74023V31.5527H3.1582ZM-0.295897 31.5527V31.8516H1.28613V31.5527H-0.295897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27734 31.6318H0.987306V32.6074H1.27734V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27734 31.6318H0.987306V32.6074H1.27734V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27734 31.6318H0.987307V32.6074H1.27734V31.6318ZM4.73145 31.6318H4.44141V32.6074H4.73145V31.6318ZM2.2002 31.6318H1.90137V32.6074H2.2002V31.6318ZM3.45703 31.6318H3.1582V32.6074H3.45703V31.6318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99805 32.3174V32.6162H3.3252V32.3174H1.99805ZM1.91016 31.5527V31.8516H2.75391V31.5527H1.91016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3984 12.6035H50.0918V12.9023H54.3984V12.6035ZM53.7568 14.0977H53.458V14.3789H53.7568V14.0977ZM50.0742 14.0801V14.3789H50.9355V14.0801H50.0742ZM49.6172 12.6035H49.3184V14.3789H49.6172V12.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8945 14.0801V14.3789H49.5293V14.0801H47.8945ZM50.9355 13.3857H50.6543V14.3789H50.9443L50.9355 13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1406 12.6035H47.8418V14.3789H48.1406V12.6035ZM48.8789 12.6035H48.5889V14.3789H48.8789V12.6035ZM52.8164 13.3066V13.6055H54.3984V13.3154L52.8164 13.3066ZM49.3623 13.3066V13.6055H50.9443V13.3154L49.3623 13.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9355 13.3857H50.6543V14.3789H50.9443L50.9355 13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9355 13.3857H50.6543V14.3789H50.9443L50.9355 13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9355 13.3857H50.6543V14.3789H50.9443L50.9355 13.3857ZM54.3896 13.3857H54.0996V14.3789H54.3896V13.3857ZM51.8584 13.3857H51.5596V14.3789H51.8584V13.3857ZM53.1152 13.3857H52.8164V14.3789H53.1152V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6562 14.0801V14.3789H52.9834V14.0801H51.6562ZM51.5684 13.3154V13.6055H52.4121V13.3154H51.5684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4824 12.6035H57.1758V12.9023H61.4824V12.6035ZM60.8408 14.0977H60.542V14.3789H60.8496L60.8408 14.0977ZM57.1582 14.0801V14.3789H58.0195V14.0801H57.1582ZM56.7012 12.6035H56.4023V14.3789H56.7012V12.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9785 14.0801V14.3789H56.6133V14.0801H54.9785ZM58.0195 13.3857H57.7295V14.3789H58.0195V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2246 12.6035H54.9258V14.3789H55.2246V12.6035ZM55.9629 12.6035H55.6729V14.3789H55.9629V12.6035ZM59.9004 13.3066V13.6055H61.4824V13.3154L59.9004 13.3066ZM56.4463 13.3066V13.6055H58.0283V13.3154L56.4463 13.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0195 13.3857H57.7295V14.3789H58.0195V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0195 13.3857H57.7295V14.3789H58.0195V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0195 13.3857H57.7295V14.3789H58.0195V13.3857ZM61.4736 13.3857H61.1836V14.3789H61.4736V13.3857ZM58.9424 13.3857H58.6523V14.3789H58.9424V13.3857ZM60.1992 13.3857H59.9004V14.3789H60.1992V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7402 14.0801V14.3789H60.0586V14.0801H58.7402ZM58.6523 13.3154V13.6055H59.4961V13.3154H58.6523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.376 12.6035H43.0693V12.9023H47.376V12.6035ZM46.7344 14.0977H46.4355V14.3789H46.7344V14.0977ZM43.0518 14.0801V14.3789H43.9131V14.0801H43.0518ZM42.5859 12.6035H42.2871V14.3789H42.5859V12.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8721 14.0801V14.3789H42.5068V14.0801H40.8721ZM43.9131 13.3857H43.6143V14.3789H43.9131V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1182 12.6035H40.8193V14.3789H41.1182V12.6035ZM41.8564 12.6035H41.5576V14.3789H41.8652L41.8564 12.6035ZM45.7939 13.3066V13.6055H47.376V13.3154L45.7939 13.3066ZM42.3398 13.3066V13.6055H43.9219V13.3154L42.3398 13.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9131 13.3857H43.6143V14.3789H43.9131V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9131 13.3857H43.6143V14.3789H43.9131V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9131 13.3857H43.6143V14.3789H43.9131V13.3857ZM47.3672 13.3857H47.0684V14.3789H47.3672V13.3857ZM44.8359 13.3857H44.5371V14.3789H44.8359V13.3857ZM46.0928 13.3857H45.7939V14.3789H46.0928V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.625 14.0801V14.3789H45.9609V14.0801H44.625ZM44.5371 13.3154V13.6055H45.3809V13.3154H44.5371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3096 12.6035H35.9941V12.9023H40.3008L40.3096 12.6035ZM39.6592 14.0977H39.3691V14.3789H39.6592V14.0977ZM35.9854 14.0801V14.3789H36.8467V14.0801H35.9854ZM35.5195 12.6035H35.2207V14.3789H35.5195V12.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7969 14.0801V14.3789H35.4316V14.0801H33.7969ZM36.8467 13.3857H36.5479V14.3789H36.8467V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.043 12.6035H33.7441V14.3789H34.043V12.6035ZM34.79 12.6035H34.4912V14.3789H34.79V12.6035ZM38.7275 13.3066V13.6055H40.3008V13.3154L38.7275 13.3066ZM35.2734 13.3066V13.6055H36.8467V13.3154L35.2734 13.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8467 13.3857H36.5479V14.3789H36.8467V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8467 13.3857H36.5479V14.3789H36.8467V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8467 13.3857H36.5479V14.3789H36.8467V13.3857ZM40.3008 13.3857H40.002V14.3789H40.3008V13.3857ZM37.7695 13.3857H37.4707V14.3789H37.7695V13.3857ZM39.0176 13.3857H38.7275V14.3789H39.0176V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5586 14.0801V14.3789H38.8857V14.0801H37.5586ZM37.4707 13.3154V13.6055H38.3145V13.3154H37.4707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.208 12.6035H28.9014V12.9023H33.208V12.6035ZM32.5664 14.0977H32.2676V14.3789H32.5664V14.0977ZM28.8838 14.0801V14.3789H29.7451V14.0801H28.8838ZM28.418 12.6035H28.1279V14.3789H28.418V12.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7041 14.0801V14.3789H28.3389V14.0801H26.7041ZM29.7451 13.3857H29.4463V14.3789H29.7451V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9502 12.6035H26.6514V14.3789H26.9502V12.6035ZM27.6885 12.6035H27.3896V14.3789H27.6885V12.6035ZM31.626 13.3066V13.6055H33.208V13.3154L31.626 13.3066ZM28.1719 13.3066V13.6055H29.7539V13.3154L28.1719 13.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7451 13.3857H29.4463V14.3789H29.7451V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7451 13.3857H29.4463V14.3789H29.7451V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7451 13.3857H29.4463V14.3789H29.7451V13.3857ZM33.1992 13.3857H32.9092V14.3789H33.1992V13.3857ZM30.668 13.3857H30.3691V14.3789H30.668V13.3857ZM31.9248 13.3857H31.626V14.3789H31.9336L31.9248 13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.457 14.0801V14.3789H31.793V14.0801H30.457ZM30.3691 13.3154V13.6055H31.2305V13.3154H30.3691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0713 12.6035H21.7646V12.9023H26.0713V12.6035ZM25.4297 14.0977H25.1309V14.3789H25.4297V14.0977ZM21.7471 14.0801V14.3789H22.6172V14.0801H21.7471ZM21.2812 12.6035H20.9912V14.3789H21.2812V12.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5674 14.0801V14.3789H21.2021V14.0801H19.5674ZM22.6084 13.3857H22.3096V14.3789H22.6172L22.6084 13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8047 12.6035H19.5147V14.3789H19.8047V12.6035ZM20.5518 12.6035H20.2529V14.3789H20.5518V12.6035ZM24.4893 13.3066V13.6055H26.0713V13.3154L24.4893 13.3066ZM21.0352 13.3066V13.6055H22.6172V13.3154L21.0352 13.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6172 13.3857H22.3096V14.3789H22.6172V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6172 13.3857H22.3096V14.3789H22.6172V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6172 13.3857H22.3096V14.3789H22.6172V13.3857ZM26.0625 13.3857H25.7637V14.3789H26.0625V13.3857ZM23.5312 13.3857H23.2324V14.3789H23.5312V13.3857ZM24.7881 13.3857H24.4893V14.3789H24.7881V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3203 14.0801V14.3789H24.6562V14.0801H23.3203ZM23.2324 13.3154V13.6055H24.0762V13.3154H23.2324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9785 12.6035H14.6719V12.9023H18.9785V12.6035ZM18.3369 14.0977H18.0381V14.3789H18.3369V14.0977ZM14.6455 14.0801V14.3789H15.5156V14.0801H14.6455ZM14.1885 12.6035H13.8896V14.3789H14.1885V12.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4746 14.0801V14.3789H14.1094V14.0801H12.4746ZM15.5156 13.3857H15.2168V14.3789H15.5156V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7119 12.6035H12.4219V14.3789H12.7119V12.6035ZM13.459 12.6035H13.1602V14.3789H13.459V12.6035ZM17.3965 13.3066V13.6055H18.9697V13.3154L17.3965 13.3066ZM13.9424 13.3066V13.6055H15.5156V13.3154L13.9424 13.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5156 13.3857H15.2168V14.3789H15.5156V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5156 13.3857H15.2168V14.3789H15.5156V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5156 13.3857H15.2168V14.3789H15.5156V13.3857ZM18.9697 13.3857H18.6709V14.3789H18.9697V13.3857ZM16.4385 13.3857H16.1396V14.3789H16.4385V13.3857ZM17.6953 13.3857H17.3965V14.3789H17.6865L17.6953 13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2275 14.0801V14.3789H17.5547V14.0801H16.2275ZM16.1396 13.3154V13.6055H16.9922V13.3154H16.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.877 12.6035H7.57031V12.9023H11.877V12.6035ZM11.2354 14.0977H10.9365V14.3789H11.2354V14.0977ZM7.55274 14.0801V14.3789H8.41406V14.0801H7.55274ZM7.09571 12.6035H6.79688V14.3789H7.09571V12.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37305 14.0801V14.3789H7.00781V14.0801H5.37305ZM8.42285 13.3857H8.12402V14.3789H8.42285V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61914 12.6035H5.32031V14.3789H5.61914V12.6035ZM6.35742 12.6035H6.06738V14.3789H6.35742V12.6035ZM10.2949 13.3066V13.6055H11.877V13.3154L10.2949 13.3066ZM6.84082 13.3066V13.6055H8.42285V13.3154L6.84082 13.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41406 13.3857H8.12402V14.3789H8.41406V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41406 13.3857H8.12402V14.3789H8.41406V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41406 13.3857H8.12402V14.3789H8.41406V13.3857ZM11.877 13.3857H11.5781V14.3789H11.877V13.3857ZM9.33691 13.3857H9.04688V14.3789H9.33691V13.3857ZM10.5938 13.3857H10.2949V14.3789H10.5938V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13477 14.0801V14.3789H10.4619V14.0801H9.13477ZM9.04687 13.3154V13.6055H9.89063V13.3154H9.04687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74023 12.6035H0.433594V12.9023H4.74023V12.6035ZM4.09863 14.0977H3.79981V14.3789H4.09863V14.0977ZM0.41602 14.0801V14.3789H1.27735V14.0801H0.41602ZM-0.0410123 12.6035H-0.339843V14.3789H-0.0410123V12.6035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.76368 14.0801V14.3789H-0.128906V14.0801H-1.76368ZM1.27734 13.3857H0.987306V14.3789H1.27734V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.51757 12.6035H-1.8164V14.3789H-1.51757V12.6035ZM-0.779296 12.6035H-1.06933V14.3789H-0.779296V12.6035ZM3.1582 13.3066V13.6055H4.74023V13.3154L3.1582 13.3066ZM-0.295897 13.3066V13.6055H1.28613V13.3154L-0.295897 13.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27734 13.3857H0.987306V14.3789H1.27734V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27734 13.3857H0.987306V14.3789H1.27734V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27734 13.3857H0.987307V14.3789H1.27734V13.3857ZM4.73145 13.3857H4.44141V14.3789H4.73145V13.3857ZM2.2002 13.3857H1.90137V14.3789H2.2002V13.3857ZM3.45703 13.3857H3.1582V14.3789H3.45703V13.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99805 14.0801V14.3789H3.3252V14.0801H1.99805ZM1.91016 13.3154V13.6055H2.75391V13.3154H1.91016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5469 29.8389H58.0195V30.7617H58.5469V29.8389ZM44.4404 29.8389H43.9131V30.7617H44.4404V29.8389ZM69.375 29.8389H68.8477V30.7617H69.375V29.8389ZM62.2119 29.8389H61.6846V30.7617H62.2119V29.8389ZM55.1016 29.8389H54.5742V30.7617H55.1016V29.8389ZM51.5859 29.8389H51.0586V30.7617H51.5859V29.8389ZM47.9912 29.8389H47.4639V30.7617H47.9912V29.8389ZM40.9248 29.8389H40.3975V30.7617H40.9248V29.8389ZM23.083 29.8389H22.5469V30.7617H23.0742L23.083 29.8389ZM37.3301 29.8389H36.8027V30.7617H37.3301V29.8389ZM33.8145 29.8389H33.2871V30.7617H33.8145V29.8389ZM30.2549 29.8389H29.7275V30.7617H30.2549V29.8389ZM26.7041 29.8389H26.1768V30.7617H26.7041V29.8389ZM-1.70215 29.8389H-2.22949V30.7617H-1.70215V29.8389ZM19.6289 29.8389H19.1016V30.7617H19.6289V29.8389ZM16.043 29.8389H15.5156V30.7617H16.043V29.8389ZM12.4131 29.8389H11.8857V30.7617H12.4131V29.8389ZM9.00293 29.8389H8.47559V30.7617H9.00293V29.8389ZM5.37305 29.8389H4.8457V30.7617H5.37305V29.8389ZM1.82227 29.8389H1.29492V30.7617H1.82227V29.8389ZM-8.69824 29.8389H-9.22559V30.7617H-8.69824V29.8389ZM-5.28809 29.8389H-5.81543V30.7617H-5.28809V29.8389ZM65.8066 29.8389H65.2793V30.7617H65.8066V29.8389Z",
    fill: "#D90000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5469 14.291H58.0195V15.2139H58.5469V14.291ZM44.4404 14.291H43.9131V15.2139H44.4404V14.291ZM69.375 14.291H68.8477V15.2139H69.375V14.291ZM62.2119 14.291H61.6846V15.2139H62.2119V14.291ZM55.1016 14.291H54.5742V15.2139H55.1016V14.291ZM51.5859 14.291H51.0586V15.2139H51.5859V14.291ZM47.9912 14.291H47.4639V15.2139H47.9912V14.291ZM40.9248 14.291H40.3975V15.2139H40.9248V14.291ZM23.083 14.291H22.5469V15.2139H23.0742L23.083 14.291ZM37.3301 14.291H36.8027V15.2139H37.3301V14.291ZM33.8145 14.291H33.2871V15.2139H33.8145V14.291ZM30.2549 14.291H29.7275V15.2139H30.2549V14.291ZM26.7041 14.291H26.1768V15.2139H26.7041V14.291ZM-1.70215 14.291H-2.22949V15.2139H-1.70215V14.291ZM19.6289 14.291H19.1016V15.2139H19.6289V14.291ZM16.043 14.291H15.5156V15.2139H16.043V14.291ZM12.4131 14.291H11.8857V15.2139H12.4131V14.291ZM9.00293 14.291H8.47559V15.2139H9.00293V14.291ZM5.37305 14.291H4.8457V15.2139H5.37305V14.291ZM1.82227 14.291H1.29492V15.2139H1.82227V14.291ZM-8.69824 14.291H-9.22559V15.2139H-8.69824V14.291ZM-5.28809 14.291H-5.81543V15.2139H-5.28809V14.291ZM65.8066 14.291H65.2793V15.2139H65.8066V14.291Z",
    fill: "#239E3F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9082 17.3584C27.1699 18.2725 24.8759 23.2998 29.288 26.6045C31.371 28.1689 30.079 28.2393 30.0175 28.5029C26.6777 26.7363 25.5966 24.3281 25.623 22.1748C25.6406 20.0303 26.7832 18.1318 27.9082 17.3584Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.469 17.1211C26.6535 17.6173 25.9585 18.2885 25.4342 19.0862C24.9099 19.8839 24.5694 20.7881 24.4374 21.7335C24.3053 22.6788 24.385 23.6418 24.6707 24.5526C24.9563 25.4634 25.4408 26.2994 26.0891 27C23.6985 26.4727 20.6399 19.4062 27.469 17.1211ZM32.5315 17.1211C33.3463 17.618 34.0405 18.2898 34.564 19.0879C35.0874 19.8859 35.427 20.7903 35.5582 21.7356C35.6894 22.6809 35.6089 23.6436 35.3226 24.5541C35.0363 25.4645 34.5512 26.2999 33.9026 27C36.302 26.4727 39.3518 19.4062 32.5315 17.1211Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0923 17.3584C32.8306 18.2725 35.1245 23.2998 30.7124 26.6045C28.6382 28.1689 29.9214 28.2393 29.9829 28.5029C33.3228 26.7363 34.4038 24.3281 34.3775 22.1748C34.3599 20.0303 33.2173 18.1318 32.0923 17.3584Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7637 28.0459C27.0732 28.0635 28.7168 27.8701 29.9385 27.2285C29.7363 27.624 29.5693 27.8701 29.3672 28.2568C28.207 28.3711 26.5986 28.5029 25.7637 28.0459ZM34.1133 28.0459C32.8037 28.0635 31.1602 27.8701 29.9385 27.2285C30.1406 27.624 30.3076 27.8701 30.5098 28.2568C31.6699 28.3711 33.2783 28.5029 34.1133 28.0459ZM31.7139 15.8555C31.4502 16.5586 30.7559 16.6641 30.0176 16.251C29.4727 16.5674 28.6377 16.5938 28.3477 15.8906C28.1279 17.6309 29.9561 17.209 30.0176 16.875C30.7031 17.5342 31.9687 17.1562 31.7139 15.8555Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9648 29.1445L29.2793 28.3535L29.1826 17.7979L30 17.0771L30.8174 17.7627L30.6504 28.3975L29.9648 29.1445Z",
    fill: "#DA0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_19734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrIran);
export default __webpack_public_path__ + "static/media/ir Iran.615a6aac5e8e68eaff774a3b5a9aac5b.svg";
export { ForwardRef as ReactComponent };